<template>
  <div>
    <div>Edit an existing GoLive unit, or add a new one.</div>

    <div class="mt-2">
      <div class="input-group mb-3 w-50">
        <input
          type="text"
          class="form-control"
          placeholder="enter a friendly unit name"
          v-model="unitName"
        />

        <button type="button" class="btn btn-primary ml-2" @click="createUnit">
          Add New Unit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddNew",
  props: {},
  data: function() {
    return {
      unitName: null,
    };
  },
  components: {},
  methods: {
    createUnit(unitName) {
      if (this.validUnitName(this.unitName)) {
        this.$emit("addNew", this.unitName);
      }
    },

    validUnitName(str) {
      if (!str) return false;
      if (!str.replace(/\s/g, "").length) return false;
      return true;
    },
  },
};
</script>
